module.exports = __webpack_public_path__ + "static/media/property_sets.237c2aae.svg";